import { render, staticRenderFns } from "./StatusChanger.vue?vue&type=template&id=281ec896&"
import script from "./StatusChanger.vue?vue&type=script&lang=js&"
export * from "./StatusChanger.vue?vue&type=script&lang=js&"
import style0 from "./StatusChanger.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VRadio,VRadioGroup})
